export const transferIncAmountCountryWise = [
    {
        country: "Anguilla",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2024",
        currency: "USD",
        amount: 15.00,
        fXYQ: 15.525,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Anguilla",
        dateFrom: "1/1/2025",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 16.50,
        fXYQ: 17.0775,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Antigua & Barbuda",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2024",
        currency: "USD",
        amount: 10.00,
        fXYQ: 10.35,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Antigua & Barbuda",
        dateFrom: "1/1/2025",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 11.00,
        fXYQ: 11.385,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Aruba",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2024",
        currency: "USD",
        amount: 10.07,
        fXYQ: 10.42245,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Aruba",
        dateFrom: "1/1/2025",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 10.17,
        fXYQ: 10.52595,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Bahamas",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 19.71,
        fXYQ: 20.39985,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Barbados",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2024",
        currency: "USD",
        amount: 9.00,
        fXYQ: 9.315,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Barbados",
        dateFrom: "1/1/2025",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 9.90,
        fXYQ: 10.2465,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    // {
    //     country: "Cuba",
    //     dateFrom: "1/1/2024",
    //     dateTo: "12/31/2026",
    //     currency: "USD",
    //     amount: 8.00,
    //     fXYQ: 8.12,
    // },
    {
        country: "Grenada",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2024",
        currency: "USD",
        amount: 15.00,
        fXYQ: 15.525,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Grenada",
        dateFrom: "11/1/2024",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 16.50,
        fXYQ: 17.0775,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    // {
    //     country: "St Kitts",
    //     dateFrom: "1/1/2024",
    //     dateTo: "12/18/2024",
    //     currency: "USD",
    //     amount: 8.00,
    //     fXYQ: 8.12,
    // },
    // {
    //     country: "St Kitts",
    //     dateFrom: "12/19/2024",
    //     dateTo: "12/18/2026",
    //     currency: "USD",
    //     amount: 8.80,
    //     fXYQ: 8.93,
    // },
    {
        country: "St Kitts",
        dateFrom: "12/19/2024",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 8.80,
        fXYQ: 9.108,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "St Lucia",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2024",
        currency: "USD",
        amount: 14.00,
        fXYQ: 14.49,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "St Lucia",
        dateFrom: "1/1/2025",
        dateTo: "12/31/2027",
        currency: "USD",
        amount: 15.40,
        fXYQ: 15.939,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Croatia",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2028",
        currency: "Eur",
        amount: 16.00,
        fXYQ: 16.56,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Cyprus",
        dateFrom: "1/1/2024",
        dateTo: "1/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-11",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Greece",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 12.00,
        fXYQ: 12.42,
        childRange: "2-11",
        childAmount: 6.00,
        childFxyq: 6.21,
    },
    {
        country: "Greece",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 12.00,
        fXYQ: 12.42,
        childRange: "2-11",
        childAmount: 6.00,
        childFxyq: 6.21,
    },
    {
        country: "Greece",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 12.00,
        fXYQ: 12.42,
        childRange: "2-11",
        childAmount: 6.00,
        childFxyq: 6.21,
    },
    {
        country: "Greece",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 12.00,
        fXYQ: 12.42,
        childRange: "2-11",
        childAmount: 6.00,
        childFxyq: 6.21,
    },
    {
        country: "Greece",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 12.00,
        fXYQ: 12.42,
        childRange: "2-11",
        childAmount: 6.00,
        childFxyq: 6.21,
    },
    {
        country: "Greece",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 12.00,
        fXYQ: 12.42,
        childRange: "2-11",
        childAmount: 6.00,
        childFxyq: 6.21,
    },
    // {
    //     country: "Italy",
    //     dateFrom: "1/1/2024",
    //     dateTo: "3/31/2030",
    //     currency: "Eur",
    //     amount: 0.00,
    //     fXYQ: 5.08,
    //     childRange: "2-11",
    //     childAmount: 0.00,
    //  childFxyq: 0.00,
    // },
    {
        country: "Malta",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Morocco (Agadir)",
        dateFrom: "1/1/2024",
        dateTo: "9/30/2030",
        currency: "Eur",
        amount: 40.00,
        fXYQ: 41.40,
        childRange: "6-12",
        childAmount: 2.00,
        childFxyq: 2.07,
    },
    {
        country: "Morocco (Marrakech)",
        dateFrom: "1/1/2024",
        dateTo: "9/30/2030",
        currency: "Eur",
        amount: 40.00,
        fXYQ: 41.40,
        childRange: "6-12",
        childAmount: 2.00,
        childFxyq: 2.07,

    },
    {
        country: "Portugal",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2025",
        currency: "Eur",
        amount: 6.00,
        fXYQ: 6.21,
        childRange: "2-12",
        childAmount: 3.00,
        childFxyq: 3.105,
    },
    {
        country: "Portugal",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2030",
        currency: "Eur",
        amount: 8.75,
        fXYQ: 9.05625,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Spain (Ibiza)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Spain (Menorca)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Spain (Fuerteventura)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Spain (Gran Canaria)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Spain (Lanzarote)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Spain (Malaga)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Spain (Mallorca)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Spain (Tenerife)",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2030",
        currency: "Eur",
        amount: 2.00,
        fXYQ: 2.07,
        childRange: "2-12",
        childAmount: 1.00,
        childFxyq: 1.035,
    },
    {
        country: "Turkey",
        dateFrom: "1/1/2024",
        dateTo: "10/31/2025",
        currency: "GBP",
        amount: 10.00,
        fXYQ: 10.35,
        childRange: "3-12",
        childAmount: 5.00,
        childFxyq: 5.175,
    },
    {
        country: "Reunion Island",
        dateFrom: "11/1/2023",
        dateTo: "10/31/2024",
        currency: "Eur",
        amount: 18.00,
        fXYQ: 18.63,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Reunion Island",
        dateFrom: "11/1/2024",
        dateTo: "12/31/2027",
        currency: "Eur",
        amount: 20.00,
        fXYQ: 20.70,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Seychelles",
        dateFrom: "11/1/2023",
        dateTo: "10/31/2024",
        currency: "GBP",
        amount: 14.00,
        fXYQ: 14.49,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Seychelles",
        dateFrom: "11/1/2024",
        dateTo: "12/31/2027",
        currency: "GBP",
        amount: 14.00,
        fXYQ: 14.49,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    {
        country: "Oman",
        dateFrom: "1/1/2024",
        dateTo: "12/31/2024",
        currency: "Eur",
        amount: 11.00,
        fXYQ: 11.385,
        childRange: "0",
        childAmount: 0.00,
        childFxyq: 0.00,
    },
    // {
    //     country: "Oman",
    //     dateFrom: "1/1/2025",
    //     dateTo: "12/31/2027",
    //     currency: "USD",
    //     amount: 12.10,
    //     fXYQ: 12.43,
    // },
];


// export const transferIncAmountCountryWise = [
//     {
//         country: "Anguilla",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2024",
//         currency: "USD",
//         amount: 15.00,
//         fXYQ: 15.23,
//     },
//     {
//         country: "Anguilla",
//         dateFrom: "1/1/2025",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 16.50,
//         fXYQ: 16.75,
//     },
//     {
//         country: "Antigua & Barbuda",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2024",
//         currency: "USD",
//         amount: 10.00,
//         fXYQ: 10.15,
//     },
//     {
//         country: "Antigua & Barbuda",
//         dateFrom: "1/1/2025",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 10.00,
//         fXYQ: 10.15,
//     },
//     {
//         country: "Aruba",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2024",
//         currency: "USD",
//         amount: 10.07,
//         fXYQ: 10.22,
//     },
//     {
//         country: "Aruba",
//         dateFrom: "1/1/2025",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 11.08,
//         fXYQ: 11.25,
//     },
//     {
//         country: "Bahamas",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 19.71,
//         fXYQ: 20.01,
//     },
//     {
//         country: "Barbados",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2024",
//         currency: "USD",
//         amount: 9.00,
//         fXYQ: 9.14,
//     },
//     {
//         country: "Barbados",
//         dateFrom: "1/1/2025",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 9.90,
//         fXYQ: 10.05,
//     },
//     {
//         country: "Cuba",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 8.00,
//         fXYQ: 8.12,
//     },
//     {
//         country: "Grenada",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2024",
//         currency: "USD",
//         amount: 15.00,
//         fXYQ: 15.23,
//     },
//     {
//         country: "Grenada",
//         dateFrom: "11/1/2024",
//         dateTo: "10/31/2026",
//         currency: "USD",
//         amount: 16.50,
//         fXYQ: 16.75,
//     },
//     {
//         country: "St Kitts",
//         dateFrom: "1/1/2024",
//         dateTo: "12/18/2024",
//         currency: "USD",
//         amount: 8.00,
//         fXYQ: 8.12,
//     },
//     {
//         country: "St Kitts",
//         dateFrom: "12/19/2024",
//         dateTo: "12/18/2026",
//         currency: "USD",
//         amount: 8.80,
//         fXYQ: 8.93,
//     },
//     {
//         country: "St Lucia",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2024",
//         currency: "USD",
//         amount: 14.00,
//         fXYQ: 14.21,
//     },
//     {
//         country: "St Lucia",
//         dateFrom: "1/1/2025",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 15.40,
//         fXYQ: 15.63,
//     },
//     {
//         country: "Croatia",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2028",
//         currency: "Eur",
//         amount: 16.00,
//         fXYQ: 16.24,
//     },
//     {
//         country: "Cyprus",
//         dateFrom: "1/1/2024",
//         dateTo: "1/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Greece",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 12.00,
//         fXYQ: 12.18,
//     },
//     {
//         country: "Italy",
//         dateFrom: "1/1/2024",
//         dateTo: "3/31/2030",
//         currency: "Eur",
//         amount: 5.00,
//         fXYQ: 5.08,
//     },
//     {
//         country: "Malta",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Morocco (Agadir)",
//         dateFrom: "1/1/2024",
//         dateTo: "9/30/2030",
//         currency: "Eur",
//         amount: 40.00,
//         fXYQ: 40.60,
//     },
//     {
//         country: "Morocco (Marrakech)",
//         dateFrom: "1/1/2024",
//         dateTo: "9/30/2030",
//         currency: "Eur",
//         amount: 40.00,
//         fXYQ: 40.60,
//     },
//     {
//         country: "Portugal",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2025",
//         currency: "Eur",
//         amount: 6.00,
//         fXYQ: 6.09,
//     },
//     {
//         country: "Portugal",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2030",
//         currency: "Eur",
//         amount: 8.75,
//         fXYQ: 8.88,
//     },
//     {
//         country: "Spain",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Spain",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Spain",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Spain",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Spain",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Spain",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Spain",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2030",
//         currency: "Eur",
//         amount: 2.00,
//         fXYQ: 2.03,
//     },
//     {
//         country: "Turkey",
//         dateFrom: "1/1/2024",
//         dateTo: "10/31/2025",
//         currency: "Eur",
//         amount: 10.00,
//         fXYQ: 10.15,
//     },
//     {
//         country: "Reunion Island",
//         dateFrom: "11/1/2023",
//         dateTo: "10/31/2024",
//         currency: "Eur",
//         amount: 18.00,
//         fXYQ: 18.50,
//     },
//     {
//         country: "Reunion Island",
//         dateFrom: "11/1/2024",
//         dateTo: "12/31/2026",
//         currency: "Eur",
//         amount: 19.80,
//         fXYQ: 20.34,
//     },
//     {
//         country: "Seychelles",
//         dateFrom: "11/1/2023",
//         dateTo: "10/31/2024",
//         currency: "GBP",
//         amount: 14.00,
//         fXYQ: 14.39,
//     },
//     {
//         country: "Seychelles",
//         dateFrom: "11/1/2024",
//         dateTo: "12/31/2026",
//         currency: "GBP",
//         amount: 15.40,
//         fXYQ: 15.82,
//     },
//     {
//         country: "Oman",
//         dateFrom: "1/1/2024",
//         dateTo: "12/31/2024",
//         currency: "USD",
//         amount: 11.00,
//         fXYQ: 11.30,
//     },
//     {
//         country: "Oman",
//         dateFrom: "1/1/2025",
//         dateTo: "12/31/2026",
//         currency: "USD",
//         amount: 12.10,
//         fXYQ: 12.43,
//     },
// ];
